export const excludedFromPropertyRelatedPaths = [
  '/financials',
  '/create-mdr',
  '/vendors',
  '/more/find-professional',
];
